import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchQyData = query => {
    
    var list = request({
        url: 'comOrder/selectQyPushPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchData = query => {

    var list = request({
        url: 'comOrder/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getChildOrder = query => {  
    
    var list = request({
        url: 'comOrder/getChildOrder.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comOrder/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comOrder/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comOrder/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const update = query => {  
    var list = request({
        url: 'comOrder/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateMore = query => {  
    var list = request({
        url: 'comOrder/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const fetchSelect = query => {  
    var list = request({
        url: 'comOrder/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getOrderDetail = query => {  
    var list = request({
        url: 'comOrderDetail/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateContact = query => {
    var list = request({
        url: 'comOrderDetail/updateContact.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getOrderStep = query => {  
    var list = request({
        url: 'comOrderStep/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const getQyOrderStep = query => {
    var list = request({
        url: 'comOrderStep/getQyList.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const getOrderStep2 = query => {  
    var list = request({
        url: 'comOrderStep/getList2.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const uploadExcel = query => {
    var list = request({
        url: '/comPhoneExcelRecord/uploadExcel',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data: query,
    });
    return list;
};
export const getOrderBack = query => {  
    var list = request({
        url: 'comOrderBack/getList.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const changeStatusMore = query => {  
    var list = request({
        url: 'comOrder/changeStatusMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const downOrderExcel = query => {  
    var list = request({
        url: 'comOrder/getOrderExcel.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const downQyOrderExcel = query => {
    var list = request({
        url: 'comOrder/getQyOrderExcel.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};


export const backSys = query => {  
    var list = request({
        url: 'comOrder/updateByBackSys.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const pushMem = query => {  
    var list = request({
        url: 'comOrder/updateByPushMem.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const falsePush = query => {  
    var list = request({
        url: 'comOrder/updateFalsePush.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const successApi = query => {  
    var list = request({
        url: 'comTask/orderSuccessApi',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const statusApi = query => {  
    var list = request({
        url: 'comOrder/changeStatusByQueryApi.do',
        //url: 'comTask/queryStatusApi', //查询全部
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const decApi = query => {  
    var list = request({
        url: 'comTask/orderDecTaskApi',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const pushApi = query => {  
    var list = request({
        url: 'comTask/pushApi',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const drawImgTest = query => {  
    var list = request({
        url: 'common/drawImgTest.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


